import {Navigate, useRoutes} from "react-router-dom";

import PlayTestLevelR3F from "~/routes/page/edit-level/play-test/PlayTestLevelR3F";

import {ProtectedRoute} from "./ProtectedRoute";
import CoopR3F from "./page/coop/CoopR3F";
import EditLevelR3F from "./page/edit-level/EditLevelR3F";
import PlayLevelR3F from "./page/play-level/PlayLevelR3F";

const Routes = () => {
  return useRoutes([
    {
      path: "/",
      element: <ProtectedRoute />,
      children: [
        {
          index: true,
          element: <Navigate to="/home" replace={true} />,
        },
        {
          path: "home",
          element: <></>,
        },
        {
          path: "play",
          element: <></>,
        },
        {
          path: "playlist/:playlistId/play/:id",
          element: <PlayLevelR3F />,
        },
        {
          path: "playlist/:playlistId/play/:id/leaderboard",
          element: <></>,
        },
        {
          path: "coop",
          element: <CoopR3F />,
        },
        {
          path: "create",
          element: <></>,
        },
        {
          path: "create/:id",
          element: <EditLevelR3F />,
        },
        {
          path: "create/:id/test",
          element: <PlayTestLevelR3F />,
        },
        {
          path: "playlist/:playlistId",
          element: <></>,
        },
        {
          path: "playlist/:playlistId/edit",
          element: <></>,
        },
      ],
    },
  ]);
};

export default Routes;
